
interface StarRatingProps {
  value: number;
  max?: number;
  showNumber?: boolean;
}

export function StarRating({ value, max = 5, showNumber = false }: StarRatingProps) {
  const percentage = (value / max) * 100;

  return (
    <div className="flex items-center gap-2">
      <div className="relative inline-flex">
        {/* ベースレイヤー（グレーの★） */}
        <div className="flex text-gray-300">
          {Array.from({ length: max }).map((_, i) => (
            <i key={i} className="ri-star-fill text-xl"></i>
          ))}
        </div>
        {/* 色付きレイヤー（黄色の★） */}
        <div
          className="absolute top-0 left-0 flex overflow-hidden text-yellow-400"
          style={{ width: `${percentage}%` }}
        >
          {Array.from({ length: max }).map((_, i) => (
            <i key={i} className="ri-star-fill text-xl"></i>
          ))}
        </div>
      </div>
      {showNumber && (
        <span className="text-sm font-medium text-gray-700">
          {value.toFixed(1)}
        </span>
      )}
    </div>
  );
}
